import React, { Component } from 'react'
import { Container, Row, Col, Card, CardText, CardBody, CardTitle, CardSubtitle } from 'reactstrap'
import Link from 'gatsby-link'
import { Parallax } from 'react-scroll-parallax'

import image_exec from '../images/image-executive.jpg'
import image_featured from '../../static/files/johnakridgefbn.png'
// import icon_play from '../images/icon_play.png'
import icon_play from '../images/icon_play_clearbgv2.png'
import image_player from '../images/image_player.png'
import thumbnail from '../images/image_thumbnail.jpg'

const roundImage = {
    borderRadius: '2000px',
}
export default class Press_Release extends Component {

    render() {
        const { posts } = this.props;

        return (
            <section className="height-press-releases">
                <Container>
                    <Row>
                        <Col className='height-press-featured' md={{size: 4}}>
                        {posts.edges.filter(post => (post.tags = post.node.frontmatter.tags.filter(tag => tag === 'featured')).length).slice(0, 1).map(({ node: post, index }) => {
                            post = post.frontmatter;
                            return (
                                <div>
                                    <div className='height-featured-image'>
                                        <Link to={post.path}>
                                            {/* <img className='icon-play' src={icon_play} /> */}
                                            {post.image_featured ? 
                                                <img className='research-image' src={post.image_featured} style={roundImage}/>
                                            : 
                                                <img className='research-image' src={thumbnail} />
                                            }
                                        </Link>
                                    </div>
                                    <header className='bebas'>Height Featured</header>
                                    <div>
                                        <Link to={post.path}>
                                            <h3 className="height-featured-h">
                                                {post.title}
                                            </h3>
                                        </Link>
                                    </div>
                                    <div className='height-tags'>
                                        <Link className='height-tag' to={'/tags/' + post.author.replace(/\s+/g, '-').toLowerCase()} key={index}>{post.author}</Link>
                                        <Link className='height-tag' to={'/categories/' + post.category.replace(/\s+/g, '-').toLowerCase()} key={index}>{post.category}</Link>
                                        {post.tags.map((tag, index) => {
                                            return (
                                            <Link className='height-tag' to={'/tags/' + tag.replace('+', '').replace('+', '').replace(/\s+/g, '-').toLowerCase()} key={index}>{tag}</Link>
                                            )
                                        })}
                                    </div>
                                </div>
                            )}
                        )}
                        </Col> 
                        
                        <Col className='height-press-executive' md={{size: 8}}>
                            <div className='executive-featured-image'>
                                <img src={image_exec} className='img-responsive' />
                                <span className='exec-subtitle'>Height</span>
                                <span className='exec-title'>Executive Insight</span>
                            </div>
            
                            <div className='executive-content'>
                                <div className='exec-copy'>
                                    <p>John Akridge co-founded Height Capital Markets in 2008, and under his leadership, the firm has grown to one of DC’s top regulatory-focused investment banks for institutional investors and companies by bridging the gap between Wall Street and DC decision-makers. The firm provides investment analysis in key regulated sectors by integrating fundamental and policy research to better understand the financial impact across the capital structure. </p>
                                    <Link to='/team/john-akridge' className="readmore-icon readmore-sm">Read More ›</Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/press-release.js